"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentEvent = exports.IncidentStatus = exports.getIncidentDSK = exports.getIncidentId = void 0;
const getIncidentId = ({ incidentEntity, incidentType, incidentSubtype, timestamp }) => {
    return `${incidentEntity.sk}:${incidentType}${incidentSubtype ? `:${incidentSubtype}` : ''}:${timestamp}`;
};
exports.getIncidentId = getIncidentId;
/**
 * DSK is a colon-separated list of:
 * - Entity SK
 * - Incident type
 * - (Optional) Incident subtype
 * - Incident initiator SK
 *
 * If there is no incident subtype, this results in:
 * `entity type : ID : incident type : incident initiator type : ID`
 *
 * If there is an incident subtype, this results in:
 * `entity type : ID : incident type : ruleset type : ID : incident initiator type : ID`
 */
const getIncidentDSK = ({ incidentEntity, incidentType, incidentSubtype, initiator }) => {
    return `${incidentEntity.sk}:${incidentType}${incidentSubtype ? `:${incidentSubtype}` : ''}:${initiator.sk}`;
};
exports.getIncidentDSK = getIncidentDSK;
var IncidentStatus;
(function (IncidentStatus) {
    IncidentStatus["OPEN"] = "OPEN";
    IncidentStatus["CLOSED"] = "CLOSED";
})(IncidentStatus || (exports.IncidentStatus = IncidentStatus = {}));
var IncidentEvent;
(function (IncidentEvent) {
    IncidentEvent["OPENED"] = "OPENED";
    IncidentEvent["UPDATED"] = "UPDATED";
    IncidentEvent["CLOSED"] = "CLOSED";
})(IncidentEvent || (exports.IncidentEvent = IncidentEvent = {}));
